import { __extends } from "tslib";
import { CompositeMethodBase, _Shader_CompositeMethodBase } from './CompositeMethodBase';
/**
 * ShadowMethodBase provides an abstract base method for shadow map methods.
 */
var ShadowMethodBase = /** @class */ (function (_super) {
    __extends(ShadowMethodBase, _super);
    /**
     * Creates a new ShadowMethodBase object.
     * @param castingLight The light used to cast shadows.
     */
    function ShadowMethodBase(castingLight) {
        var _this = _super.call(this, castingLight.shadowMapper) || this;
        _this._castingLight = castingLight;
        return _this;
    }
    Object.defineProperty(ShadowMethodBase.prototype, "castingLight", {
        /**
         * The light casting the shadows.
         */
        get: function () {
            return this._castingLight;
        },
        enumerable: false,
        configurable: true
    });
    return ShadowMethodBase;
}(CompositeMethodBase));
export { ShadowMethodBase };
/**
 * ShadowHardChunk provides the cheapest shadow map method by using a single tap
 * without any filtering.
 */
var _Shader_ShadowMethodBase = /** @class */ (function (_super) {
    __extends(_Shader_ShadowMethodBase, _super);
    function _Shader_ShadowMethodBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new ShadowHardChunk.
     */
    _Shader_ShadowMethodBase.prototype.init = function (method, shader) {
        _super.prototype.init.call(this, method, shader);
        this._method = method;
        this._shader = shader;
    };
    _Shader_ShadowMethodBase.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        this._baseTexture = this._baseChunk.texture;
    };
    return _Shader_ShadowMethodBase;
}(_Shader_CompositeMethodBase));
export { _Shader_ShadowMethodBase };
